import React, { useState } from "react";
import { LayoutMain } from "../../../boxes/LayoutMain/LayoutMain";
import { Box } from "../../../shared/Box/Box";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
import classes from "./PatientQuestionnaire.module.scss";
import { usePatientQuestionnaireQuery } from "../../../api/questionnaires/patientQuestionnaires/usePatientQuestionnaireQuery";
import { getPathParams } from "./PatientQuestionnaire.utils";
import { uiNotification } from "../../../services/UINotificationService";
import { extractQuestionnaireStatus } from "../../../utilities/api";
import { Button } from "../../../shared/Button/Button";
import { Loading } from "../../../boxes/Loading/Loading";
import { PatientQuestionnairePreview } from "../../../widgets/PatientQuestionnairePreview/PatientQuestionnairePreview";
import { ModalPatientQuestionnaireFill } from "../../../widgets/ModalPatientQuestionnaireFill/ModalPatientQuestionnaireFill";
import { history } from "../../../history";
import { CrossIcon } from "../../../assets/Icons/CrossIcon";
import { FillButton } from "../shared/FillButton/FillButton";
import { ChevronLeftIcon } from "../../../assets/Icons/ChevronLeftIcon";

export function PatientQuestionnaire() {
  const { tCommon } = useAppTranslation.Common();
  const { patientQuestionnaireId } = getPathParams();
  const [isFillModalOpen, setIsFillModalOpen] = useState(false);

  const {
    data: patientQuestionnaire,
    isLoading,
    refetch,
  } = usePatientQuestionnaireQuery({
    payload: {
      patientQuestionnaireId: patientQuestionnaireId,
    },
    options: {
      enabled: Boolean(patientQuestionnaireId),
      onError: () => {
        uiNotification.error(tCommon("error.fetchQuestionnaire"));
      },
    },
  });

  const status = extractQuestionnaireStatus(patientQuestionnaire);

  const isLoaderVisible = isLoading;
  const isContentVisible = !isLoaderVisible;

  return (
    <LayoutMain>
      <Box className={classes.root}>
        <div className={classes.header}>
          <Button variant="text" size="small" onClick={() => history.goBack()}>
            <ChevronLeftIcon />
          </Button>
          {status === "notFilled" ? (
            <FillButton
              onClick={() => setIsFillModalOpen(true)}
              status={status}
              isPartiallyFilled={patientQuestionnaire.step_history?.length > 0}
            />
          ) : (
            <Button variant="text" size="tiny" onClick={() => history.goBack()}>
              <CrossIcon width="17px" />
            </Button>
          )}
        </div>
        {isLoaderVisible && <Loading center />}
        {isContentVisible && (
          <PatientQuestionnairePreview
            preloadedPatientQuestionnaire={patientQuestionnaire}
            infoClassName={classes.info}
          />
        )}
      </Box>
      {isFillModalOpen && (
        <ModalPatientQuestionnaireFill
          isOpen
          onClose={() => setIsFillModalOpen(false)}
          preloadedPatientQuestionnaire={patientQuestionnaire}
          onSuccess={() => {
            refetch();
            setIsFillModalOpen(false);
          }}
        />
      )}
    </LayoutMain>
  );
}
